import Vue from 'vue'
import Vuex from 'vuex'
import navStore from '@/stores/nav'
import orderStore from '@/stores/order'
import viewportStore from '@/stores/viewport'
import pageStore from '@/stores/page'
import storeStore from '@/stores/store'
import flashStore from '@/stores/flash'
import dynamicYieldStore from '@/stores/dynamic-yield'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    // Global stores only. Use "stores" option of newVue() otherwise.
    nav: navStore,
    order: orderStore,
    store: storeStore,
    viewport: viewportStore,
    page: pageStore,
    flash: flashStore,
    dynamicYield: dynamicYieldStore,
  },
})
window.On.Store = store

export default store
